module.exports = __webpack_public_path__ + "9bcd50bcfbfaf00b10a1ae2a3d0d8b52.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/diamonds.png
// module id = 3359
// module chunks = 0